import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { DeploymentObject } from 'api';
import { Observable } from 'rxjs';
import { DeploymentsService } from '../deployments.service';

@Injectable({
  providedIn: 'root',
})
export class FirewallRunningGuard implements CanActivate {
  constructor(private deploymentsService: DeploymentsService) {}
  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.deploymentsService.deployments) return true;
    if (route.paramMap.get('deploymentId') == '') return false;
    const currentDeployment = this.deploymentsService.findDeployment(
      this.deploymentsService.deployments,
      route.paramMap.get('deploymentId'),
    ) as DeploymentObject;
    if (!currentDeployment) return false;
    if (
      currentDeployment.deploymenttype != 'hcc' &&
      currentDeployment.deploymenttype != 'fhiraas' &&
      currentDeployment.deploymenttype != 'ics'
    )
      return false;
    if (currentDeployment.status != 'COMPLETE') return false;
    if (currentDeployment.deploymenttype == 'fhiraas' && currentDeployment.service_status != 'RUNNING') return false;
    if (currentDeployment.deploymenttype == 'fhiraas' && !currentDeployment.configuration.enableSqlBuilder)
      return false;
    return true;
  }
}
